function main() {
  var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

  if (vw < 992) {
    return;
  }

  var logoContainer = $('.desktop-logo-container');
  var isLogoCollapsed = false;
  var oldScrollPosition = 0;

  var wdw = $(window);

  wdw.on('scroll', function() {
    var scrollPosition = wdw.scrollTop();

    if (scrollPosition - oldScrollPosition > 0 && !isLogoCollapsed) {
      isLogoCollapsed = true;
      logoContainer.addClass('collapsed');
    } else if ((scrollPosition === 0 || scrollPosition - oldScrollPosition < 0) && isLogoCollapsed) {
      isLogoCollapsed = false;
      logoContainer.removeClass('collapsed');
    }

    oldScrollPosition = scrollPosition;
  });
}

$('document').ready(main);